"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TrashCanIcon = ({
  color,
  title,
  ...otherProps
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "29",
    viewBox: "0 0 25 29",
    children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        fill: color,
        fillRule: "nonzero",
        transform: "translate(-636 -555)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(636 555)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M23 6l-1.841 21.173A2 2 0 0119.166 29H5.834a2 2 0 01-1.993-1.827L2 6h21zm-2.182 2H4.181l1.653 19h13.332l1.652-19z"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M12.5 0c1.716 0 3.075.667 4.076 2H23a2 2 0 012 2v4H0V4a2 2 0 012-2h6.424C9.425.667 10.784 0 12.5 0zm0 2c-1.02 0-1.753.327-2.35 1.042l-.127.159-.6.799H2v2h21V4h-7.423l-.6-.799C14.357 2.375 13.592 2 12.5 2z"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M12.5 10.75a.75.75 0 01.743.648l.007.102v12a.75.75 0 01-1.493.102l-.007-.102v-12a.75.75 0 01.75-.75zM17.562 10.753a.75.75 0 01.687.707l-.002.102-1 12a.75.75 0 01-1.496-.022l.002-.102 1-12a.75.75 0 01.707-.687l.102.002zM7.438 10.753a.75.75 0 01.794.584l.015.1 1 12a.75.75 0 01-1.48.226l-.014-.1-1-12a.75.75 0 01.685-.81z"
          })]
        })
      })
    })]
  });
};

TrashCanIcon.defaultProps = {
  color: "currentColor",
  title: undefined
};
var _default = TrashCanIcon;
exports.default = _default;